import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { WritingResult } from './WritingResult';

@Injectable()
export class WritingService {
  constructor(private http: HttpClient) {}

  checkText(text: string) {
    return this.http.get<WritingResult>('/tools/writing', {
      params: new HttpParams().set('text', text),
    });
  }
}



// WEBPACK FOOTER //
// ./ts/app/shared/writing/writing.service.ts